import { Box, IconButton, styled, Typography } from "@mui/material";

export const TitleSignup = styled(Typography)(({ theme }) => ({
  color: "#272A30",
  textAlign: "left",
  fontFamily: "Open Sans",
  fontSize: "38.42px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "140%",
  letterSpacing: "-1.153px",
  padding: "2.4rem 0",
}));

export const StyledBox = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  [theme.breakpoints.down(600)]: {
    flexDirection: "column",
    gap: "2rem",
  },
}));

export const StyledBoxLeft = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "left",
  marginTop: theme.spacing(4),
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
}));
export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: "#b5d9ff",
  fontSize: "12px",
  borderRadius: "8px",
  fontWeight: 700,
  color: "#094f99",
}));
